import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { commissions } from '@services/api'
import { StoreExt } from '@utils/reactExt'

export class mentorCommissionStore extends StoreExt {
    @observable mentorCommissions = []
    @observable loadingMentorCommissions = false

    @action
    getMentorCommissions = (payload) => {
        this.loadingMentorCommissions = true
        return commissions.getMentorCommissionsByAgentClient(payload)
        .then((res) => {
            runInAction(() => {
                this.mentorCommissions = res.data
            })
        })
        .finally(() => {
            runInAction(() => {
                this.loadingMentorCommissions = false
            })
        })
    }

    @action
    resetList = () => this.mentorCommissions = []
   
}

export default remotedev(new mentorCommissionStore())
